import {Component, Input} from '@angular/core';
import {FormArray, FormBuilder} from "@angular/forms";
import {IProjetAnnee} from "../../model/projet-annee.model";
import {IProjetAnneeAvis} from "../../model/projet-annee-avis.model";
import {TypeAvisEnum} from "../../constant/enum";
import {IDdcUser} from "../../model/ddc-user.model";
import {AuthenticationService} from "../../service/authentication.service";

@Component({
    selector: 'ddc-projet-annee-avis',
    templateUrl: './projet-annee-avis.component.html',
    styleUrls: ['./projet-annee-avis.component.scss'],
    standalone: false
})
export class ProjetAnneeAvisComponent  {


  @Input() set avisToDisplay(avisToDisplay: []){
    this._avisToDisplay = avisToDisplay;
  };

 @Input() set projetAnneeAvisFormArray(projetAnneeAvisFormArray: FormArray) {
    this._projetAnneeAvisFormArray = projetAnneeAvisFormArray;
 }

  @Input() set currentProjetAnnee(currentProjetAnnee: IProjetAnnee){
    this._currentProjetAnnee = currentProjetAnnee;
  }

  @Input() set descriptionLabelKey(descriptionLabelKey: string) {
    this._descriptionLabelKey = descriptionLabelKey;
  }

  @Input() set titleLabelKey(titleLabelKey: string) {
    this._titleLabelKey = titleLabelKey;
  }

  @Input() set currentUser(_currentUserValue: IDdcUser) {
    this._currentUser = _currentUserValue;
  }




  _currentUser : IDdcUser
  _currentProjetAnnee : IProjetAnnee
  _projetAnneeAvisFormArray : FormArray;
  _avisToDisplay: IProjetAnneeAvisParameters[] = []
  _titleLabelKey: string;
  _descriptionLabelKey: string;

  constructor(
    protected fb: FormBuilder,
    private authenticationService : AuthenticationService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  getAvisProjetAnneeToDisplay() {
    const avisToDisplay = this._avisToDisplay
    return avisToDisplay
  }

  getAvisProjetAnneeFormControl(avis, formControlName: string) {
    const allTmpProjetAnneeAvis = this._projetAnneeAvisFormArray.getRawValue();
    const index = allTmpProjetAnneeAvis.findIndex((tmpProjetAnneeAvis: IProjetAnneeAvis ) => tmpProjetAnneeAvis.typeAvis === avis.typeAvis);
    if (index !== -1) {
      return this._projetAnneeAvisFormArray.at(index).get(formControlName);
    }
    return null;
  }
}


export interface IProjetAnneeAvisParameters {
  typeAvis: TypeAvisEnum
  listAvis: IProjetAnneeListAvis[];
  labelKey: string;
  droit: string;
}

export interface IProjetAnneeListAvis {
  value: string;
  text: string;
}
